import uuidv1 from 'uuid';
import {
  REPORT_LOAD_DATA,
  REPORT_LOAD_DATA_SUCCESS,
  REPORT_LOAD_DATA_FAILURE,
  REPORT_CLEAR_DATA,
  REPORT_DOWNLOAD_RESULT_REQUEST,
  REPORT_DOWNLOAD_RESULT_SUCCESS,
  REPORT_DOWNLOAD_RESULT_FAILURE,
  REPORT_CUSTOM_FILTER_UPDATE,
  REPORT_CUSTOM_FILTER_CLEAR,
  REPORT_SORTING_CHANGE,
  REPORT_FILTERING_CHANGE,
  REPORT_MODE_CHANGE,
  CHANGE_ASYNC,
  REPORT_LOAD_DATA_CANCELED,
  CANCEL_REPORT_REQUEST,
  CANCEL_REPORT_SUCCESS,
  CANCEL_REPORT_FAILURE,
  SWITCH_TO_ASYNC_REPORT_REQUEST,
  SWITCH_TO_ASYNC_REPORT_SUCCESS,
  SWITCH_TO_ASYNC_REPORT_FAILURE,
  SWITCH_TO_ASYNC_ENABLED_REQUEST,
  SWITCH_TO_ASYNC_ENABLED_SUCCESS,
  SWITCH_TO_ASYNC_ENABLED_FAILURE,
  CANCEL_REPORT_ENABLED_REQUEST,
  CANCEL_REPORT_ENABLED_SUCCESS,
  CANCEL_REPORT_ENABLED_FAILURE,
} from './types/ReportActionTypes';

export function fetchDownloadReportResultActionCreator(reportName, execId, batchNo) {
  return {
    type: REPORT_DOWNLOAD_RESULT_REQUEST,
    payload: {
      reportName,
      execId,
      batchNo,
      requestId: uuidv1(),
    },
  };
}

export function fetchDownloadReportResultSuccessActionCreator(payload, request) {
  return {
    type: REPORT_DOWNLOAD_RESULT_SUCCESS,
    payload,
    meta: request,
  };
}

export function fetchDownloadReportResultFailureActionCreator(error, request) {
  return {
    type: REPORT_DOWNLOAD_RESULT_FAILURE,
    payload: error,
    error: true,
    meta: request,
  };
}

/**
 * Reports that require selection criteria as a parameter
 * @param {ReportDefinitionModel} reportDefinition
 * @param {string} mainReportId
 * @param {Object} requestParams payload parameters that will be sent with request
 */
export function reportLoadData(reportDefinition, mainReportId, requestParams) {
  return {
    type: REPORT_LOAD_DATA,
    payload: {
      reportDefinition,
      mainReportId,
      requestParams,
    },
  };
}

/**
 * Returns generic success callback parameters for loaded report
 * @param {ReportDefinitionModel} reportDefinition
 * @param {string} mainReportId
 * @param {Object} reportData
 * @param {Object} requestParams
 */
export function reportLoadDataSuccess(reportDefinition, mainReportId, reportData, requestParams) {
  return {
    type: REPORT_LOAD_DATA_SUCCESS,
    payload: {
      reportDefinition,
      mainReportId,
      requestParams,
      metadata: { ...reportData.metadata },
      data: [...reportData.data],
    },
  };
}

/**
 * Returns generic failure callback parameters for loaded report
 * @param {ReportDefinitionModel} reportDefinition
 * @param {string} mainReportId
 * @param {Object} error
 */
export function reportLoadDataFailure(reportDefinition, mainReportId, error) {
  return {
    type: REPORT_LOAD_DATA_FAILURE,
    payload: {
      reportDefinition,
      mainReportId,
      error,
    },
  };
}

/**
 * Returns parameters for cleared report
 * @param {ReportDefinitionModel} reportDefinition
 */
export function reportClearData(reportDefinition = { reportDefinition: null }) {
  return {
    type: REPORT_CLEAR_DATA,
    payload: {
      reportDefinition,
    },
  };
}

export function reportLoadDataCanceled() {
  return {
    type: REPORT_LOAD_DATA_CANCELED,
  };
}

export function updateReportCustomFilter(payload) {
  return {
    type: REPORT_CUSTOM_FILTER_UPDATE,
    payload,
  };
}

export function clearReportCustomFilter() {
  return {
    type: REPORT_CUSTOM_FILTER_CLEAR,
  };
}

export function changeReportSorting(payload) {
  return {
    type: REPORT_SORTING_CHANGE,
    payload,
  };
}

export function changeReportFiltering(payload) {
  return {
    type: REPORT_FILTERING_CHANGE,
    payload,
  };
}

export function changeReportMode(payload) {
  return {
    type: REPORT_MODE_CHANGE,
    payload,
  };
}

export function changeAsync(payload) {
  return {
    type: CHANGE_ASYNC,
    payload,
  };
}

export function cancelReportRequestActionCreator(feRequestId) {
  return {
    type: CANCEL_REPORT_REQUEST,
    payload: {
      feRequestId,
    },
  };
}

export function cancelReportSuccessActionCreator(response) {
  return {
    type: CANCEL_REPORT_SUCCESS,
    payload: response,
  };
}

export function cancelReportFailureActionCreator(error) {
  return {
    type: CANCEL_REPORT_FAILURE,
    payload: error,
    error: true,
  };
}

export function switchToAsyncReportRequestActionCreator(feRequestId) {
  return {
    type: SWITCH_TO_ASYNC_REPORT_REQUEST,
    payload: {
      feRequestId,
    },
  };
}

export function switchToAsyncReportSuccessActionCreator(response) {
  return {
    type: SWITCH_TO_ASYNC_REPORT_SUCCESS,
    payload: response,
  };
}

export function switchToAsyncReportFailureActionCreator(error) {
  return {
    type: SWITCH_TO_ASYNC_REPORT_FAILURE,
    payload: error,
    error: true,
  };
}

export function switchToAsyncEnabledRequestActionCreator(feRequestId) {
  return {
    type: SWITCH_TO_ASYNC_ENABLED_REQUEST,
    payload: {
      feRequestId,
    },
  };
}

export function switchToAsyncEnabledSuccessActionCreator(response) {
  return {
    type: SWITCH_TO_ASYNC_ENABLED_SUCCESS,
    payload: response,
  };
}

export function switchToAsyncEnabledFailureActionCreator(error) {
  return {
    type: SWITCH_TO_ASYNC_ENABLED_FAILURE,
    payload: error,
    error: true,
  };
}

export function cancelReportEnabledRequestActionCreator(feRequestId) {
  return {
    type: CANCEL_REPORT_ENABLED_REQUEST,
    payload: {
      feRequestId,
    },
  };
}

export function cancelReportEnabledSuccessActionCreator(response) {
  return {
    type: CANCEL_REPORT_ENABLED_SUCCESS,
    payload: response,
  };
}

export function cancelReportEnabledFailureActionCreator(error) {
  return {
    type: CANCEL_REPORT_ENABLED_FAILURE,
    payload: error,
    error: true,
  };
}
